import { Box, BoxProps } from '@mui/material';
import React from 'react';

export interface CardProps extends Omit<BoxProps, 'borderRadius'> {
  borderRadius?: number | string;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({ children, borderRadius = '16px', ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      height={'100%'}
      width={'inherit'}
      overflow={'hidden'}
      boxSizing={'border-box'}
      borderRadius={borderRadius}
      {...rest}>
      {children}
    </Box>
  );
});

Card.displayName = 'Card';
